import { createContext } from "react";

export type User = {
  id: number;
  username: string;
  email: string;
  fullName: string;
  phone: string | null;
  role: string;
  twoFactorEnabled: boolean | null;
  avatarUrl: string | null;
  createdAt: string;
};

export type AuthContextType = {
  user: User | null;
  isLoading: boolean;
  login: (username: string, password: string) => Promise<User>;
  register: (data: any) => Promise<User>;
  logout: () => Promise<void>;
};

// Singleton pattern: if Replit's CDN causes this module to be evaluated
// more than once (preload URL ?v=xxx ≠ import URL), all evaluations share
// the same context object via globalThis, so AuthProvider and useAuth
// always see the same reference.
const SINGLETON_KEY = "__ifixable_auth_ctx_v1__";
const _g = globalThis as Record<string, unknown>;
if (!_g[SINGLETON_KEY]) {
  _g[SINGLETON_KEY] = createContext<AuthContextType | null>(null);
}
export const AuthContext = _g[SINGLETON_KEY] as ReturnType<
  typeof createContext<AuthContextType | null>
>;
